import React from 'react';
import { Alert, AlertTitle, Box, Button } from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';

interface ErrorMessageProps {
  /**
   * Error message to display
   */
  message: string;

  /**
   * Optional error title (default: "Fehler")
   */
  title?: string;

  /**
   * Optional retry callback
   */
  onRetry?: () => void;

  /**
   * Show retry button (default: true if onRetry provided)
   */
  showRetry?: boolean;

  /**
   * Severity level (default: "error")
   */
  severity?: 'error' | 'warning' | 'info';
}

/**
 * Reusable Error Message Component
 * Displays error alert with optional retry button
 */
export default function ErrorMessage({
  message,
  title = 'Fehler',
  onRetry,
  showRetry = true,
  severity = 'error',
}: ErrorMessageProps) {
  return (
    <Box p={2}>
      <Alert
        severity={severity}
        action={
          showRetry && onRetry ? (
            <Button
              color="inherit"
              size="small"
              startIcon={<RefreshIcon />}
              onClick={onRetry}
            >
              Erneut versuchen
            </Button>
          ) : undefined
        }
      >
        {title && <AlertTitle>{title}</AlertTitle>}
        {message}
      </Alert>
    </Box>
  );
}
